<template>
  <div id="content">
    <div class="header col-md-12">
      <div class="header-inner row align-items-center">
        <div class="col left">
          <div class="title">
            {{ $t('sidebar.purchaseorder') }} > {{ $t('sidebar.create') }}
          </div>
        </div>
      </div>
    </div>

    <div class="content col-md-12">

      <p v-if="!ready">{{ $t('message.loading') }}</p>

      <template v-if="ready">
        <section>
          <div class="col-md-12 no-padding">
            <section-header
              :title="$t('message.vendor')"
              :subtitle="$t('series.po') + ' ' + nextPoCode"/>
            <div class="form-row">
              <div class="col-md-12">
                <div class="form-group row">
                  <div class="col">
                    <label>{{ $t('message.storecompanyperson') }}</label>
                    <selectize
                      v-model="form.pickedVendorId"
                      :default="form.defaultVendorId"
                      :updateoption="form.updateOptionVendor"
                      :options="form.optionVendors"
                      :multiple="false"
                      :create="true"
                      :loading="form.loadingVendor"
                      :validation="form.trickValidationVendor"
                      :placeholder="$t('placeholder.selectorcreate')"
                      @add="onAddedVendor" />
                  </div>
                </div>
              </div>
            </div>
            <div
              v-if="form.pickedVendorId"
              class="form-row">
              <div class="col-md-6">
                <div
                  class="form-group row"
                  style="height: 100%;">
                  <div class="col-md-12">
                    <label>{{ $t('message.address') }}</label>
                    <textarea
                      v-model="form.vendor.address"
                      class="form-control"
                      style="height: calc(100% - 37px);"/>
                  </div>
                </div>
              </div>
              <div class="col-md-6">
                <div class="form-group row">
                  <div class="col-md-12">
                    <label>{{ $t('message.tel') }}</label>
                    <input
                      v-model="form.vendor.tel"
                      type="text"
                      class="form-control">
                  </div>
                </div>
                <div class="form-group row">
                  <div class="col-md-12">
                    <label>{{ $t('message.email') }}</label>
                    <input
                      v-model="form.vendor.email"
                      type="text"
                      class="form-control">
                  </div>
                </div>
                <div class="form-group row">
                  <div class="col-md-12">
                    <label>{{ $t('message.taxpayerno') }}</label>
                    <input
                      v-model="form.vendor.tax_id"
                      type="text"
                      class="form-control">
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
        <section>
          <div class="col-md-12 no-padding">
            <section-header :title="$t('message.date')"/>
            <div class="form-row">
              <div class="col">
                <div class="form-group row">
                  <div class="col">
                    <label>{{ $t('message.date') }}</label>
                    <BaseInputDatePicker
                      v-model="form.created_at"
                    />
                  </div>
                </div>
              </div>
              <div class="col">
                <div class="form-group row">
                  <div class="col">
                    <label>{{ $t('apps.purchases.message.purchasetype') }}</label>
                    <BaseDropdown
                      v-model="form.purchase_type"
                      :options="purchaseOptions"
                    />
                  </div>
                </div>
              </div>
              <div
                class="col"
                @click="isFocusOnInputScheduled = false">
                <div class="form-group row">
                  <div class="col">
                    <label>{{ $t('message.credittype') }}</label>
                    <select
                      v-if="form.selectedCredit !== 'custom'"
                      v-model="form.selectedCredit"
                      class="form-control custom-select">
                      <option value="cash">{{ $t('message.cash') }}</option>
                      <option value="days.15">{{ $t('message.creditdasys', {number: 15}) }}</option>
                      <option value="days.30">{{ $t('message.creditdasys', {number: 30}) }}</option>
                      <option value="days.60">{{ $t('message.creditdasys', {number: 60}) }}</option>
                      <option value="days.90">{{ $t('message.creditdasys', {number: 90}) }}</option>
                      <option value="custom">{{ $t('message.customcreditdays') }}</option>
                    </select>
                    <div
                      v-else
                      class="input-group">
                      <input
                        ref="custom_credit_days"
                        v-model="form.inputCustomCreditDay"
                        type="text"
                        class="form-control text-right number-only text-select-all"
                        style="border-right: none;"
                        @keyup="keyupInputCustomCreditDay">
                      <div class="input-group-prepend">
                        <button
                          class="btn btn-web"
                          type="button"
                          style="border: 1px solid #ced4da;"
                          @click="form.selectedCredit = 'cash'">
                          {{ $t('message.creditdasysbutton') }} <i class="far fa-times-circle"/>
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div
                v-if="form.selectedCredit !== 'cash'"
                :class="{'disabled': false}"
                class="col scheduled">
                <div class="form-group row">
                  <div
                    class="col-md-12"
                    style="position: relative;">
                    <div class="overlay"/>
                    <label>{{ $t('message.scheduled_at') }}</label>
                    <BaseInputDatePicker
                      v-model="form.scheduled_at"
                      :availableDates="{ start: form.created_at, end: null }"
                      @dayclick="isFocusOnInputScheduled = true"
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
        <section>
          <div class="col-md-12 no-padding">
            <section-header :title="$t('message.orderlist')"/>
            <order
              :validation="form.trickValidation"
              :data="form.orders"
              :createAble="true"
              :showProductImage="true"
              :showTooltipTaxHint="showTooltipTaxHint"
              type="po"
              @submit="onSubmitOrder"
            />
          </div>
        </section>
        <section class="no-margin">
          <div class="col-md-12 no-padding">
            <div class="form-row">
              <div class="col-md-6">
                <div class="form-group row">
                  <div class="col-md-12">
                    <b-form-textarea
                      :placeholder="$t('placeholder.note')"
                      v-model="form.note"
                      style="min-height: 126px;" />
                  </div>
                </div>
              </div>
              <div class="col-md-6 pl-2">
                <div class="col-md-12 row no-padding no-margin">
                  <div class="col-12 row no-margin no-padding">
                    <div class="col-6 no-padding mb-2">
                      {{ $t('message.total') }}
                    </div>
                    <div class="col-6 no-padding mb-2 text-right">
                      {{ getNumber(total.sub) }}
                    </div>
                  </div>
                  <div
                    v-if="total.discount > 0"
                    class="col-12 row no-margin no-padding">
                    <div class="col-6 no-padding mb-2">
                      {{ $t('message.discount') }}
                    </div>
                    <div class="col-6 no-padding mb-2 text-right">
                      {{ getNumber(total.discount) }}
                    </div>
                  </div>
                  <div
                    v-if="total.discount > 0"
                    class="col-12 row no-margin no-padding">
                    <div class="col-6 no-padding mb-2">
                      {{ $t('message.discounted_total') }}
                    </div>
                    <div class="col-6 no-padding mb-2 text-right">
                      {{ getNumber(total.sub - total.discount) }}
                    </div>
                  </div>
                  <div
                    v-if="total.taxes.vat.inclusive > 0"
                    class="col-12 row no-margin no-padding">
                    <div class="col-6 no-padding mb-2">
                      {{ $t('message.totalexcludingvat') }}
                    </div>
                    <div class="col-6 no-padding mb-2 text-right">
                      {{ getNumber(total.untaxed) }}
                    </div>
                  </div>
                  <div
                    v-for="(tax, index) in taxResults"
                    :key="index"
                    class="col-12 row no-margin no-padding"
                  >
                    <div class="col-6 no-padding mb-2">
                      {{ tax.displayText }}
                    </div>
                    <div class="col-6 no-padding mb-2 text-right">
                      {{ getNumber(tax.total) }}
                    </div>
                  </div>
                  <div class="col-12 row no-margin no-padding">
                    <div class="col-6 no-padding">
                      {{ $t('message.grandtotal') }}
                    </div>
                    <div class="col-6 no-padding text-right">
                      <span :class="[{'text-underline-border': !form.switchWithHoldingTax}]">
                        {{ getNumber(total.grand) }}
                      </span>
                    </div>
                  </div>
                  <div
                    v-if="showLegacyWht()"
                    class="col-12 row no-margin no-padding">
                    <div class="col-12 no-padding"><hr style="border-top: solid 1px #D8E2E7;"></div>
                  </div>
                </div>
                <template v-if="showLegacyWht()">
                  <div
                    class="form-group row mb-0"
                    style="height: 35px;">
                    <div
                      class="col-8"
                      style="position: relative; top: 3px;opacity: 0.3;"
                      @click="showTooltipTaxHint = true"
                    >
                      <vs-switch
                        v-model="form.switchWithHoldingTax"
                        :disabled="true"
                        style="float: left;margin: 0 10px 0 0"
                        color="#A3CA76"
                      />
                      {{ $t('message.wht') }}
                    </div>
                    <div class="col-4">
                      <select
                        v-if="form.switchWithHoldingTax"
                        v-model="form.inputWithHoldingTax"
                        class="custom-select form-control">
                        <option value="0">0%</option>
                        <option value="-1">{{ $t('message.wht1') }}</option>
                        <option value="-2">{{ $t('message.wht2') }}</option>
                        <option value="-3">{{ $t('message.wht3') }}</option>
                        <option value="-5">{{ $t('message.wht5') }}</option>
                      </select>
                    </div>
                  </div>
                  <div
                    v-if="form.switchWithHoldingTax"
                    class="col-md-12 row no-padding mt-2 ml-0 mr-0">
                    <div class="col-12 row no-margin no-padding">
                      <div class="col-6 no-padding mb-2">
                        {{ $t('message.wht') }}
                      </div>
                      <div class="col-6 no-padding mb-2 text-right">
                        {{ getNumber(total.taxes.wht.toString().replace("-", "")) }}
                      </div>
                    </div>
                    <div class="col-12 row no-margin no-padding">
                      <div class="col-6 no-padding">
                        {{ $t('message.paymentamount') }}
                      </div>
                      <div class="col-6 no-padding text-right">
                        <span class="text-underline-border">{{ getNumber(total.payment) }}</span>
                      </div>
                    </div>
                  </div>
                </template>
              </div>
            </div>
          </div>
        </section>
        <section class="action-bar">
          <template>
            <div
              v-if="!$store.state.app.loading"
              class="col-md-12 text-right">
              <!-- <button class="btn btn-light btn-block-mobile-only"
                      @click="clearForm()">{{ $t('button.cancel') }}</button> -->
              <div class="btn-group">
                <button
                  type="button"
                  class="btn btn-web"
                  @click="form.trickValidation++;isCreateAnother = false;">{{ $t('button.save') }}</button>
                <button
                  type="button"
                  class="btn btn-web dropdown-toggle dropdown-toggle-split"
                  data-toggle="dropdown"
                  aria-haspopup="true"
                  aria-expanded="false">
                  <span class="sr-only">Toggle Dropdown</span>
                </button>
                <div class="dropdown-menu dropdown-menu-right">
                  <a
                    class="dropdown-item"
                    @click="form.trickValidation++;isCreateAnother = true;">{{ $t('button.saveandcreateanother') }}</a>
                </div>
              </div>
            </div>
            <div
              v-else
              class="col-md-12 text-right">
              <!-- <button class="btn btn-light btn-block-mobile-only" disabled>{{ $t('button.cancel') }}</button> -->
              <div class="btn-group">
                <button
                  type="button"
                  class="btn btn-web"
                  disabled><i class="fas fa-spinner spin"/></button>
                <button
                  type="button"
                  class="btn btn-web dropdown-toggle dropdown-toggle-split"
                  data-toggle="dropdown"
                  aria-haspopup="true"
                  aria-expanded="false"
                  disabled>
                  <span class="sr-only">Toggle Dropdown</span>
                </button>
                <div class="dropdown-menu"/>
              </div>
            </div>
          </template>
        </section>
      </template>
    </div>

    <BaseConfirmDiscardModal
      :show="confirmDiscardModal.show"
      @onCancel="handleDiscardCancleModal"
      @onConfirm="handleDiscardConfirmModal"
    />

  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'

import sidebarModule from './../../sidebarModule'
import _ from 'lodash'
import discardFormMixin from '@/mixins/discardForm'
import userPermissionMixin from '@/mixins/userPermission'
import { getMasterDataText } from '../../../../helpers'

export default {
  mixins: [discardFormMixin, userPermissionMixin],
  data () {
    return {
      ready: false,

      form: {
        pickedVendorId: null,
        defaultVendorId: null,
        optionVendors: [],
        updateOptionVendor: null,
        loadingVendor: false,
        trickValidationVendor: 0,
        vendor: {
          address: null,
          tax_id: null,
          email: null,
          tel: null,
        },

        created_at: new Date(),

        purchase_type: null,

        scheduled_at: new Date(),
        selectedCredit: 'cash',

        inputCustomCreditDay: 0,
        inputWithHoldingTax: 0,

        switchWithHoldingTax: false,

        note: '',
        trickValidation: 0,
        orders: [],
      },

      originalForm: null,

      isFocusOnInputScheduled: false,

      isCreateAnother: false,

      formats: {
        title: 'MMMM YYYY',
        weekdays: 'WWW',
        navMonths: 'MMM',
        input: null,
        dayPopover: null,
      },

      showTooltipTaxHint: false,
    }
  },
  computed: {
    ...mapGetters({
      products: 'getProducts',
      vendors: 'getVendors',
      nextPoCode: 'getNextPoCode',
      currency: 'getCurrency',
      dateformat: 'getDateFormat',
      vat: 'getVat',
      getVendorById: 'getVendorById',
      getPartnerContact: 'getPartnerContact',
      getDataSetPartnerUpdate: 'getDataSetPartnerUpdate',
      purchaseSetting: 'getPurchaseSetting',
    }),
    purchaseTypes() {
      if (this.purchaseSetting && this.purchaseSetting.types) {
        return this.purchaseSetting.types
      }
      return []
    },
    purchaseOptions() {
      return this.purchaseTypes
        .filter((type) => type.is_active)
        .map((type) => {
          return {
            text: getMasterDataText(type.name, this.$t),
            value: type.name,
          }
        })
    },
    defaultPurchaseType() {
      return this.purchaseTypes.find((type) => type.is_default).name
    },
    total () {
      let oders = this.getDataSetOrders(this.form.orders)
      return this.getTotal(oders)
    },
    taxResults () {
      const isGroupTaxName = false
      const oders = this.getDataSetOrders(this.form.orders)
      return this.getTaxesByOrders(oders, isGroupTaxName).map((tax) => {
        return {
          form_type: tax.form_type,
          taxRate: tax.amount,
          total: (() => {
            if (tax.amount <= -1) {
              return Math.abs(tax.total)
            }
            return tax.total
          })(),
          displayText: tax.displayText,
        }
      })
    },
  },
  methods: {
    ...mapActions([

    ]),
    async onAddedVendor (value) {
      // show loading selectize
      this.form.loadingVendor = true

      // insert new vendor
      let res = await this.$store.dispatch('insertVendor', { name: value })

      if (res.success) {
        let vendor = res.data
        // update option value
        this.form.updateOptionVendor = {
          text: value,
          value: vendor.vendor_id,
          picked: true,
        }
        this.form.optionVendors.push({
          text: value,
          value: vendor.vendor_id,
        })
        // finish loading
        this.showFinish(this.$Progress)
        // hide loading selectize
        this.form.loadingVendor = false
      }
    },
    onSubmitOrder (isValid, orders) {
      this.form.trickValidationVendor++

      let isInValid = !isValid || (this.form.pickedVendorId == null || this.form.pickedVendorId == '')

      if (isInValid) {
        return $('html, body').animate({ scrollTop: 0 }, 'slow')
      }

      this.save(this.getDataSetOrders(orders))
    },
    async save (orders) {
      let creditType = 'cash'
      let creditDays = 0

      if (this.form.selectedCredit == 'custom') {
        creditType = 'days'
        creditDays = this.form.inputCustomCreditDay
      } else if (this.form.selectedCredit.search('days.') >= 0) {
        let arr = this.form.selectedCredit.split('.')
        let days = arr[1]
        creditType = 'days'
        creditDays = days
      }

      let dataSet = {
        'doc_type': 'po',
        'status': 'padding',
        'note': this.form.note ? this.form.note : null,
        'created_at': this.form.created_at.toISOString(),
        'scheduled_at': this.form.scheduled_at.toISOString(),
        'vendor_id': this.form.pickedVendorId,
        'purchase_type': this.form.purchase_type,
        'credit': {
        	'type': creditType,
        	'days': parseInt(creditDays),
        },
        'orders': [],
      }

      for (let i in orders) {
        let order = orders[i]
        dataSet['orders'].push({
          'item': order.item,
        	'description': order.description,
        	'price': order.price,
        	'quantity': order.quantity,
        	'sku_id': order.sku_id,
          'discounts': order.discounts,
          'taxes': order.taxes,
        })
      }

      // update vendor
      let dataSetVendorUpdate = this.getDataSetPartnerUpdate('vendor', this.form.pickedVendorId, this.form.vendor, this.vendors)
      if (dataSetVendorUpdate !== null) {
        await this.$store.dispatch('updateVendor', dataSetVendorUpdate)
        await this.$store.dispatch('getVendors')
      }

      let res = await this.$store.dispatch('insertPurchase', dataSet)

      if (res.success) {
        let newPurchase = res.data.purchase

        // show notify
        this.notify(this.$vs, {
          text: this.$t('message.hasbeencreated', { msg: newPurchase.po_code }),
          color: 'success',
          icon: 'cloud',
        })

        if (!this.isCreateAnother) {
          return this.$router.push({
            name: 'PurchaseOrderEdit',
            query: {
              id: newPurchase._id,
              code: newPurchase.po_code,
              ignoreDiscardAlert: true,
            },
          })
        } else {
          // clear form
          this.clearForm()
        }
      }
    },
    getDataSetOrders (orders) {
      const data = _.cloneDeep(orders)
      const newData = []
      // remove key, data we don't need
      for (const i in data) {
        const item = data[i]
        if (item.sku_id) {
          newData.push({
            item: item.item,
            description: item.description,
            sku_id: item.sku_id,
            quantity: parseFloat(item.quantity) || 0,
            price: parseFloat(item.price) || 0,
            discounts: item.discounts.map((discount) => ({
              ...discount,
              type: 'general',
              value_amount: parseFloat(discount.value_amount),
            })),
            taxes: item.taxes.map((tax) => ({
              name: tax.tax_name,
              type: tax.type,
              amount: tax.amount,
              form_type: tax.form_type,
              group_name: tax.group_name,
              is_display_fee_result: tax.is_display_fee_result,
              is_for_sale: tax.is_for_sale,
              is_for_purchase: tax.is_for_purchase,
              fee: tax.fee ? tax.fee : null,
              tax_id: tax.tax_id,
            })),
          })
        }
      }
      return newData
    },
    async clearForm () {
      let that = this

      this.ready = false

      this.form = _.cloneDeep(this.originalForm)

      // get next code
      await this.$store.dispatch('getNextPoCode', { doc_type: 'po' })

      that.ready = true

      // scroll to top
      $('html, body').animate({ scrollTop: 0 }, 'slow')
    },
    keyupInputCustomCreditDay (e) {
      var value = this.form.inputCustomCreditDay.toString()
      if (value) {
        if (value.search('0') == 0) {
          value = value.substring(1, value.length)
          this.form.inputCustomCreditDay = value
        }
      }
    },
  },
  watch: {
    ready: function () {
      // loading finish
      this.showFinish(this.$Progress)
    },
    vendors: function (after, before) {
      this.form.optionVendors = []
      for (let i in after) {
        let vendor = after[i]
        this.form.optionVendors.push({
          text: vendor.vendor_name,
          value: vendor.vendor_id,
        })
      }
    },
    'form.switchWithHoldingTax': {
      handler: function (after) {
        let bool = after
        if (bool == false) {
          this.form.inputWithHoldingTax = '0'
        }
      },
      deep: true,
    },
    'form.selectedCredit': {
      handler: function (after, before) {
        let value = after
        if (value.search('days.') >= 0) {
          let arr = value.split('.')
          let days = parseInt(arr[1])
          this.form.scheduled_at = this.moment(this.form.created_at).add(days, 'day').toDate()
        } else if (value == 'custom') {
          let that = this
          if (!this.isFocusOnInputScheduled) {
            if (before.search('days.') >= 0) {
              let arr = before.split('.')
              let days = parseInt(arr[1])
              this.form.inputCustomCreditDay = days
            } else {
              this.form.scheduled_at = this.moment(this.form.created_at).toDate()
              this.form.inputCustomCreditDay = 0
            }
          }
          setTimeout(() => {
            that.$refs.custom_credit_days.focus()
          }, 100)
        } else if (value == 'cash') {
          this.form.scheduled_at = this.moment(this.form.created_at).toDate()
        }
      },
      deep: true,
    },
    'form.created_at': {
      handler: function (after) {
        var days = null

        if (this.form.selectedCredit == 'custom') {
          days = parseInt(this.form.inputCustomCreditDay)
        } else if (this.form.selectedCredit.search('days.') >= 0) {
          let arr = this.form.selectedCredit.split('.')
          days = parseInt(arr[1])
        }

        if (days !== null) {
          this.form.scheduled_at = this.moment(this.form.created_at).add(days, 'day').toDate()
        }
      },
      deep: true,
    },
    'form.scheduled_at': {
      handler: function (after, before) {
        if (this.isFocusOnInputScheduled) {
          if (this.form.selectedCredit.search('days.') >= 0 || this.form.selectedCredit == 'custom') {
            var a = this.moment(this.form.scheduled_at)
            var b = this.moment(this.form.created_at)
            var diff = Math.round(a.diff(b, 'days', true)) // diff days
            this.form.inputCustomCreditDay = diff
            this.form.selectedCredit = 'custom'
          }
        }
      },
      deep: true,
    },
    'form.inputCustomCreditDay': {
      handler: function (after) {
        var value = after.toString()
        let days = parseInt(value)
        if (days >= 0) {
          this.form.scheduled_at = this.moment(this.form.created_at).add(days, 'day').toDate()
        } else {
          this.form.inputCustomCreditDay = 0
        }
      },
      deep: true,
    },
    'form.pickedVendorId': {
      handler: function (after) {
        let vendor_id = after
        let vendorInfo = this.getVendorById(vendor_id)

        this.form.vendor.address = null
        this.form.vendor.tax_id = null
        this.form.vendor.email = null
        this.form.vendor.tel = null

        if (vendorInfo) {
          this.form.vendor.address = vendorInfo.address
          this.form.vendor.tax_id = vendorInfo.tax_id
          this.form.vendor.email = this.getPartnerContact(vendorInfo.contacts).email
          this.form.vendor.tel = this.getPartnerContact(vendorInfo.contacts).tel
        }
      },
      deep: true,
    },
  },
  beforeCreate: function () {

  },
  created: async function () {
    // set date format
    this.formats.input = [this.dateformat]
    this.formats.dayPopover = this.dateformat
    // get vendors
    await this.$store.dispatch('getVendors')
    // get next code
    await this.$store.dispatch('getNextPoCode', { doc_type: 'po' })
    // get taxes
    await this.$store.dispatch('getTaxes')
    // set originalForm
    this.originalForm = _.cloneDeep(this.form)
    // set default form
    this.form.purchase_type = this.defaultPurchaseType
    // set ready
    this.ready = true
  },
  beforeMount: function () {
    // init page
    this.initPage({
      section: 'app',
      name: this.$t('app.purchases.title'),
      current: {
        app_name: 'purchases',
        app_id: 4,
        module_id: 1,
      },
    })
    // set sidebar ui
    sidebarModule.init(this.getObject(require('../sidebar.json')), {
      sidebarAtIdx: 1,
      submenuAtIdx: 1,
    })
  },
  mounted: function () {

  },
  destroyed: function () {
    this.leavePage(this.$Progress, ['clearProducts', 'clearVendors'])
  },
}
</script>

<style scoped>
  .scheduled {
    position: relative;
  }
  .scheduled .overlay {
    display: none;
  }
  .scheduled.disabled .overlay {
    position: absolute;
    width: -webkit-calc(100% - 30px);
  	width:    -moz-calc(100% - 30px);
  	width:         calc(100% - 30px);
    height: 38px;
    top: 32px;
    left: 15px;
    z-index: 1;
    display: block;
  }
</style>

<style>
.scheduled.disabled .popover-container input {
  background: #e9ecef !important;
}
</style>



// WEBPACK FOOTER //
// src/components/apps/purchases/po/New.vue